import React, { useEffect, useState } from 'react';
import {
    Alert,
    TextInput,
    View,
    StyleSheet,
    TouchableOpacity,
    Image,
    ImageBackground,
    TouchableHighlight,
    FlatList,
    Platform,
    Text,
} from 'react-native';
import { RFPercentage } from 'react-native-responsive-fontsize';

// import {
//     MajmoehScreen
// } from '../screens';
import { numberWithCommas } from '../utils/price';
import CustomButton from '../components/shared/CustomButton';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import Screen from './../components/shared/Screen';
import ToplearnText from './../components/shared/ToplearnText';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getKholasehVaziat, getCourses } from './../actions/index';
import { loadingToast } from '../utils/toasts';
import Toast from 'react-native-tiny-toast';
import MajmoehScreen from './majmoehScreen';
import ModalSelector from 'react-native-modal-selector';
import Modal from 'modal-react-native-web';

const MyCoursesScreen = () => {
    const [visible, setVisible] = useState(false);
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const hstry = useSelector((state) => state.historyes);
    const zrmjm = useSelector((state) => state.zrmajmoeh);
    const [currentHesab, setCurrentHesab] = useState(user.hesab);
    useEffect(() => {
        try {
            const fetchData = async () => {
                loadingToast('در حال بارگذاری...');
                if (hstry.length != 0) {
                    dispatch(
                        getKholasehVaziat({
                            hesab: currentHesab,
                            sal: hstry[0].sal,
                            mah: hstry[0].mah,
                            usr: user,
                        })
                    );
                }
                Toast.hide();
            };
            fetchData();
        } catch (err) {
            console.log(err);
            Toast.hide();
        }
    }, [hstry, currentHesab]);

    const kholasehVaziat = useSelector((state) => state.kholasehVaziats);

    return (
        <Screen style={styles.container}>
            <Image
                blurRadius={5}
                style={styles.headerImage}
                source={require('../assets/sepordehBKG.jpg')}
            />
            <View style={styles.header}>
                <ToplearnText fontFamily="yekan" size="1.8" color="#fff">
                    {hstry.length !== 0 ? hstry[0].mahname : '-'}{' '}
                    {hstry.length !== 0 ? hstry[0].sal : '-'}
                </ToplearnText>
                <View style={styles.headerPerson}>
                    {Platform.OS !== 'web' ? (
                        <ModalSelector
                            data={zrmjm}
                            keyExtractor={(item) => item.hesab}
                            labelExtractor={(item) =>
                                item.firstName +
                                ' ' +
                                item.lastName +
                                ' (شناسه: ' +
                                item.shenaseh +
                                ')'
                            }
                            initValue="Select something yummy!"
                            supportedOrientations={['landscape']}
                            accessible={true}
                            scrollViewAccessibilityLabel={'Scrollable options'}
                            cancelButtonAccessibilityLabel={'Cancel Button'}
                            onChange={(option) => {
                                setCurrentHesab(option.hesab);
                            }}
                        >
                            <Image
                                style={styles.prsn}
                                source={require('../assets/PersonPic.png')}
                            />
                        </ModalSelector>
                    ) : (
                        <View>
                            <Modal
                                animationType="slide"
                                transparent={false}
                                visible={visible}
                                onDismiss={() => {}}
                            >
                                <View
                                    style={{
                                        marginTop: '10%',
                                        width: '100%',
                                        textAlign: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <View>
                                        <ToplearnText
                                            fontFamily="yekan"
                                            size="2"
                                            color="tomato"
                                        >
                                            انتخاب
                                        </ToplearnText>
                                        {zrmjm.map((zrmjmh, index) => (
                                            <TouchableHighlight
                                                onPress={() => {
                                                    setCurrentHesab(
                                                        zrmjmh.hesab
                                                    );
                                                    setVisible(!visible);
                                                }}
                                            >
                                                <Text
                                                    style={[
                                                        {
                                                            fontFamily: 'yekan',
                                                            fontSize:
                                                                RFPercentage(
                                                                    1.5
                                                                ),
                                                            color: 'black',
                                                        },
                                                    ]}
                                                >
                                                    {zrmjmh.firstName}{' '}
                                                    {zrmjmh.lastName}
                                                </Text>
                                            </TouchableHighlight>
                                        ))}
                                        <View style={{ width: '100%' }}>
                                            <CustomButton
                                                title="بازگشت"
                                                color="royalblue"
                                                onPress={() =>
                                                    setVisible(!visible)
                                                }
                                            />
                                        </View>
                                    </View>
                                </View>
                            </Modal>
                            <TouchableHighlight
                                onPress={() => {
                                    setVisible(true);
                                }}
                            >
                                <Image
                                    style={styles.prsn}
                                    source={require('../assets/PersonPic.png')}
                                />
                            </TouchableHighlight>
                        </View>
                    )}
                    <ToplearnText fontFamily="yekan" size="2" color="#fff">
                        {kholasehVaziat.length !== 0
                            ? kholasehVaziat[0].firstName
                            : '-'}{' '}
                        {kholasehVaziat.length !== 0
                            ? kholasehVaziat[0].lastName
                            : '-'}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5" color="#fff">
                        شناسه{' '}
                        {kholasehVaziat.length !== 0
                            ? kholasehVaziat[0].shenaseh
                            : '-'}
                    </ToplearnText>
                    <View style={styles.headerSepordeh}>
                        <Image
                            style={styles.seperatIcon}
                            source={require('../assets/Sandogh.png')}
                        />
                        <ToplearnText
                            fontFamily="yekan"
                            size="2.5"
                            color="black"
                        >
                            {kholasehVaziat.length !== 0
                                ? kholasehVaziat[0].ekhSepordeh === 0
                                    ? ' - '
                                    : ` ${numberWithCommas(
                                          kholasehVaziat[0].ekhSepordeh
                                      )} `
                                : '-'}
                        </ToplearnText>
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            color="black"
                        >
                            ریال
                        </ToplearnText>
                    </View>
                </View>
            </View>
            <View style={styles.containerBody}>
                <View style={styles.seperatDetails}>
                    <View style={styles.seperatMablagh}>
                        <Image
                            style={styles.seperatIcon}
                            source={require('../assets/Adi.png')}
                        />
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            color="green"
                        >
                            {kholasehVaziat.length !== 0
                                ? kholasehVaziat[0].ekhAdi === 0
                                    ? ' - '
                                    : ` ${numberWithCommas(
                                          kholasehVaziat[0].ekhAdi
                                      )} `
                                : '-'}
                        </ToplearnText>
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            color="black"
                        >
                            ریال
                        </ToplearnText>
                    </View>
                    {/* <MaterialCommunityIcons
                        name={'chevron-left'}
                        size={30}
                        color={'black'}
                    /> */}
                </View>
                <View style={styles.seperatDetails}>
                    <View style={styles.seperatMablagh}>
                        <Image
                            style={styles.seperatIcon}
                            source={require('../assets/Kargoshaie.png')}
                        />
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            color="green"
                        >
                            {kholasehVaziat.length !== 0
                                ? kholasehVaziat[0].ekhKargoshaie === 0
                                    ? ' - '
                                    : ` ${numberWithCommas(
                                          kholasehVaziat[0].ekhKargoshaie
                                      )} `
                                : '-'}
                        </ToplearnText>
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            color="black"
                        >
                            ریال
                        </ToplearnText>
                    </View>
                    {/* <MaterialCommunityIcons
                        name={'chevron-left'}
                        size={30}
                        color={'black'}
                    /> */}
                </View>
                <View style={styles.seperatDetails}>
                    <View style={styles.seperatMablagh}>
                        <Image
                            style={styles.seperatIcon}
                            source={require('../assets/Zarori.png')}
                        />
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            color="green"
                        >
                            {kholasehVaziat.length !== 0
                                ? kholasehVaziat[0].ekhZarori === 0
                                    ? ' - '
                                    : ` ${numberWithCommas(
                                          kholasehVaziat[0].ekhZarori
                                      )} `
                                : '-'}
                        </ToplearnText>
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            color="black"
                        >
                            ریال
                        </ToplearnText>
                    </View>
                    {/* <MaterialCommunityIcons
                        name={'chevron-left'}
                        size={30}
                        color={'black'}
                    /> */}
                </View>
                <View style={styles.seperatDetails}>
                    <View style={styles.seperatMablagh}>
                        <Image
                            style={styles.seperatIcon}
                            source={require('../assets/Jarimeh.png')}
                        />
                        <ToplearnText fontFamily="yekan" size="1.5" color="red">
                            {kholasehVaziat.length !== 0
                                ? kholasehVaziat[0].jrmMandeh === 0
                                    ? ' - '
                                    : ` ${numberWithCommas(
                                          kholasehVaziat[0].jrmMandeh
                                      )} `
                                : '-'}
                        </ToplearnText>
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            color="black"
                        >
                            ریال
                        </ToplearnText>
                    </View>
                    {/* <MaterialCommunityIcons
                        name={'chevron-left'}
                        size={30}
                        color={'black'}
                    /> */}
                </View>
            </View>
            <View style={styles.containerFooter}>
                <View style={styles.ksriAsli}>
                    <View style={styles.ksriDetails}>
                        <Image
                            style={styles.ksriIcon}
                            source={require('../assets/kasri.png')}
                        />
                        <View style={styles.seperatMablagh}>
                            <Image
                                style={styles.ksriSepordehIcon}
                                source={require('../assets/Sandogh.png')}
                            />
                            <ToplearnText
                                fontFamily="yekan"
                                size="1.5"
                                color="red"
                            >
                                {kholasehVaziat.length !== 0
                                    ? kholasehVaziat[0].ksrSepordeh === 0
                                        ? ' - '
                                        : ` ${numberWithCommas(
                                              kholasehVaziat[0].ksrSepordeh
                                          )} `
                                    : '-'}
                            </ToplearnText>
                            <ToplearnText
                                fontFamily="yekan"
                                size="1.5"
                                color="black"
                            >
                                ریال
                            </ToplearnText>
                        </View>
                    </View>
                    <View style={styles.ksriDetails2}>
                        <View style={styles.seperatMablagh}>
                            <Image
                                style={styles.ksriSepordehIcon}
                                source={require('../assets/Adi.png')}
                            />
                            <ToplearnText
                                fontFamily="yekan"
                                size="1.5"
                                color="red"
                            >
                                {kholasehVaziat.length !== 0
                                    ? kholasehVaziat[0].ksrAdi === 0
                                        ? ' - '
                                        : ` ${numberWithCommas(
                                              kholasehVaziat[0].ksrAdi
                                          )} `
                                    : '-'}
                            </ToplearnText>
                            <ToplearnText
                                fontFamily="yekan"
                                size="1.5"
                                color="black"
                            >
                                ریال
                            </ToplearnText>
                        </View>
                        <View style={styles.seperatMablagh}>
                            <Image
                                style={styles.ksriSepordehIcon}
                                source={require('../assets/Kargoshaie.png')}
                            />
                            <ToplearnText
                                fontFamily="yekan"
                                size="1.5"
                                color="red"
                            >
                                {kholasehVaziat.length !== 0
                                    ? kholasehVaziat[0].ksrKargoshaie === 0
                                        ? ' - '
                                        : ` ${numberWithCommas(
                                              kholasehVaziat[0].ksrKargoshaie
                                          )} `
                                    : '-'}
                            </ToplearnText>
                            <ToplearnText
                                fontFamily="yekan"
                                size="1.5"
                                color="black"
                            >
                                ریال
                            </ToplearnText>
                        </View>
                    </View>
                    <View style={(styles.ksriDetails2, { marginTop: 10 })}>
                        <View style={styles.seperatMablagh}>
                            <Image
                                style={styles.ksriSepordehIcon}
                                source={require('../assets/Zarori.png')}
                            />
                            <ToplearnText
                                fontFamily="yekan"
                                size="1.5"
                                color="red"
                            >
                                {kholasehVaziat.length !== 0
                                    ? kholasehVaziat[0].ksrZarori === 0
                                        ? ' - '
                                        : ` ${numberWithCommas(
                                              kholasehVaziat[0].ksrZarori
                                          )} `
                                    : '-'}{' '}
                            </ToplearnText>
                            <ToplearnText
                                fontFamily="yekan"
                                size="1.5"
                                color="black"
                            >
                                ریال
                            </ToplearnText>
                        </View>
                    </View>
                    <Image
                        style={styles.ksributtomIcon}
                        source={require('../assets/kasriBottom.png')}
                    />
                </View>
            </View>
        </Screen>
    );
};

export default MyCoursesScreen;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
    header: {
        position: 'absolute',
        width:'95%',
        padding:5
    },
    headerImage: {
        width: '95%',
        resizeMode: 'cover',
        borderRadius: 15,
        padding: 5,
        height: Platform.OS === 'web' ? 230 : 165,
        marginBottom:Platform.OS==='web'?50: 30,
    },
    headerPerson: {
        alignItems: 'center',
    },
    headerSepordeh: {
        flexDirection: 'row',
        //marginTop: Platform.OS === 'web' ? '0%' : 10,
        width: '60%',
        height: Platform.OS === 'web' ? 50 : 15,
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: 14,
        justifyContent: 'space-between',
        padding: 30,
        //shadowColor: 'red',
        //shadowOpacity: 3,
    },


    containerHeader: {
        flexDirection: 'row',
        width: '95%',
        height: Platform.OS === 'web' ? 230 : 165,
        // paddingLeft: 20,
        // paddingRight: 20,
    },
    containerBody: {
        //marginTop: Platform === 'web' ? '5%' : 12,
        paddingLeft: 40,
        paddingRight: 40,
        height: '30%',
        width: '100%',
        alignItems: 'center',
    },
    containerFooter: {
        //backgroundColor: 'tomato',
        height: '30%',
        width: '90%',
        borderRadius: 10,
        alignItems: 'center',
    },

    details: {
        marginLeft: 10,
        backgroundColor: '#f8f4f4',
        width: '100%',
        padding: 10,
        borderRadius: 14,
        alignItems: 'center',
    },

    seperatIcon: {
        width: Platform.OS === 'web' ? 40 : 30,
        height: Platform.OS === 'web' ? 40 : 30,
        resizeMode: 'contain',
    },
    ksriIcon: {
        width: Platform.OS === 'web' ? 90 : 80,
        height: Platform.OS === 'web' ? 90 : 80,
        resizeMode: 'contain',
        marginBottom: 20,
        marginRight: 20,
    },
    ksriSepordehIcon: {
        width: Platform.OS === 'web' ? 40 : 30,
        height: Platform.OS === 'web' ? 40 : 30,
        resizeMode: 'contain',
    },
    ksributtomIcon: {
        width: '100%',
        resizeMode: 'contain',
    },
    prsn: {
        width: Platform.OS === 'web' ? 90 : 50,
        height: Platform.OS === 'web' ? 90 : 50,
        borderRadius: 10,
    },
    adi: {
        flexDirection: 'column',
        width: '90%',
        height: '20%',
        marginTop: 60,
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 10,
        backgroundColor: 'white',
        borderRadius: 14,
    },
    seperatMablagh: {
        flexDirection: 'row',
        width: '40%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    seperatDetails: {
        flexDirection: 'row',
        width: '90%',
        height: '20%',
        marginTop: 8,
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 10,
        backgroundColor: 'white',
        borderRadius: 14,
    },
    ksriDetails: {
        flexDirection: 'row',
        width: '90%',
        //marginTop: 15,
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingLeft: 10,
        backgroundColor: 'white',
        borderRadius: 14,
    },
    ksriDetails2: {
        flexDirection: 'row',
        width: '90%',
        //marginTop: 15,
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: 10,
        backgroundColor: 'white',
        borderRadius: 14,
    },
    ksriAsli: {
        width: '90%',
        marginTop: 15,
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: 14,
    },
});
